/* IvitaPure — Crealyte PDP (cpdp). Idempotent: tål att laddas av flera sektioner.
   Varje cpdp-sektion länkar skriptet, så det kan köras många gånger. Bara första
   körningen gör något: den kopplar in allt som finns och lyssnar på
   shopify:section:load för det som temaredigeraren lägger till senare. */
(function () {
  if (window.__cpdpMain) return;
  window.__cpdpMain = true;

  /* ---------- 1 · Infade när sektioner scrollas in ----------
     Körs både vid sidladdning och när temaredigeraren laddar om en sektion.
     Utan omkörningen står nyinlagda element kvar med opacity 0. */
  if (!window.__cpdpRevealIn) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var revealIO = (!reduceMotion && 'IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 })
      : null;
    window.__cpdpRevealIn = function (root) {
      var scope = (root && root.querySelectorAll) ? root : document;
      scope.querySelectorAll('.cpdp .cpdp-reveal, .cpdp-reveal').forEach(function (el) {
        if (el.__cpdpRevealBound) return;
        el.__cpdpRevealBound = true;
        if (revealIO) { revealIO.observe(el); } else { el.classList.add('is-in'); }
      });
    };
    window.__cpdpRevealIn(document);
    document.addEventListener('shopify:section:load', function (e) { window.__cpdpRevealIn(e.target); });
  }

  /* Meddelanderaden under nivåerna. Standardtexten (planen saknas) sparas första
     gången, så att ett felmeddelande från varukorgen inte blir kvar till nästa gång. */
  function showPlanBlock(pb, text) {
    if (!pb) return;
    if (!pb.hasAttribute('data-default-text')) pb.setAttribute('data-default-text', pb.textContent);
    pb.textContent = text || pb.getAttribute('data-default-text') || '';
    pb.hidden = false;
  }

  /* ---------- 2 · Köpbox: vald nivå styr variant, plan och prissuffix ----------
     Knapptexten rörs aldrig: bara priset och besparingsraden följer nivån. En tom/avstängd
     selling_plan-input skickas inte med i POST:en, så engångsköp förblir engångsköp. */
  function initBuybox(box) {
    if (!box || box.__cpdpBound) return;
    box.__cpdpBound = true;
    var form = box.querySelector('[data-cpdp-form]');
    if (!form) return;
    var radios = Array.prototype.slice.call(form.querySelectorAll('.cpdp-tier-radio'));
    var variantInput = form.querySelector('[data-cpdp-variant]');
    var planInput = form.querySelector('[data-cpdp-plan]');
    /* Antal per leverans. En nivå kan vara ett flerpack av samma variant, och då
       ligger antalet på nivån i stället för i en egen flerpacksvariant. */
    var qtyInput = form.querySelector('[data-cpdp-qty]');
    var ctaPrice = form.querySelector('[data-cpdp-cta-price]');
    /* Besparingsraden i knappen. Ordet före beloppet ("Du sparar") kommer från
       elementets data-label, så inget svenskt ord är hårdkodat här. */
    var ctaSave = form.querySelector('[data-cpdp-cta-save]');
    var submit = form.querySelector('[data-cpdp-submit]');
    if (!radios.length || !variantInput) return;
    /* Knappen renderas disabled (ett tidigt tryck skulle skicka ett tomt id).
       Klassen säger till CSS att en disabled knapp nu verkligen är låst. */
    form.classList.add('cpdp-buyform--ready');

    var planBlock = form.querySelector('[data-cpdp-plan-block]');

    /* En nivå vars prenumerationsplan inte finns i butiken än får vara förvald
       och synas, men går inte att lägga i varukorgen: då skulle den säljas som
       engångsköp till fel pris. Stoppas här innan AJAX-köpet i steg 3 ser det. */
    form.addEventListener('submit', function (e) {
      var picked = radios.filter(function (r) { return r.checked; })[0];
      if (picked && picked.dataset.planMissing === 'true') {
        e.preventDefault();
        e.stopPropagation();
        showPlanBlock(planBlock, '');
      }
    });

    function sync() {
      if (planBlock) planBlock.hidden = true;
      var picked = radios.filter(function (r) { return r.checked && !r.disabled; })[0];
      if (!picked) {
        picked = radios.filter(function (r) { return !r.disabled; })[0];
        if (picked) picked.checked = true;
      }
      if (!picked) {                       /* ingen nivå går att köpa */
        if (submit) { submit.disabled = true; submit.setAttribute('aria-disabled', 'true'); }
        return;
      }
      if (submit) { submit.disabled = false; submit.removeAttribute('aria-disabled'); }
      variantInput.value = picked.dataset.variant || '';
      if (qtyInput) qtyInput.value = picked.dataset.qty || '1';
      var plan = picked.dataset.plan || '';
      if (planInput) {
        planInput.value = plan;
        planInput.disabled = !plan;
      }
      if (ctaPrice) ctaPrice.textContent = picked.dataset.price || '';
      if (ctaSave) {
        var save = picked.dataset.save || '';
        var saveLabel = ctaSave.getAttribute('data-label') || '';
        ctaSave.textContent = save ? (saveLabel ? saveLabel + ' ' + save : save) : '';
        ctaSave.hidden = !save;
      }
      radios.forEach(function (r) {
        var label = r.closest('.cpdp-tier');
        if (label) label.classList.toggle('is-picked', r === picked);
      });
    }

    radios.forEach(function (r) { r.addEventListener('change', sync); });
    sync();
  }

  document.querySelectorAll('[data-cpdp-buybox]').forEach(initBuybox);
  /* sektionen kan laddas om i temaredigeraren */
  document.addEventListener('shopify:section:load', function (e) {
    var t = e.target || document;
    t.querySelectorAll && t.querySelectorAll('[data-cpdp-buybox]').forEach(initBuybox);
  });

  /* ---------- 3 · Lägg i varukorgen utan omladdning → varukorgslådan ----------
     Samma mekanik som temats vanliga produktsida.
     - Varan lades till (2xx): händelsen cpdp:cart-added skickas på formuläret
       (sticky-skriptet skickar då Klaviyo-händelsen och kontrollerar nivån på
       varukorgen), sedan ritas lådan. Kastar ritningen, eller saknas lådans
       HTML i svaret, går sidan till varukorgen: varan finns redan där, så
       formuläret skickas aldrig en gång till.
     - 422 (slut i lager, ogiltig säljplan): Shopifys förklaring visas i
       meddelanderaden, ingen omladdning till felsidan.
     - Nätverksfel, oläsbart svar eller annat serverfel innan varan lagts till:
       vanlig POST, så ett köp aldrig blockeras. */
  if (!window.__cpdpCart) {
    window.__cpdpCart = true;
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.matches || !f.matches('form[data-cpdp-form]')) return;
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function') return;
      e.preventDefault();
      var btn = f.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      var fd = new FormData(f);
      fd.append('sections', 'cart-drawer,cart-icon-bubble');
      fd.append('sections_url', window.location.pathname);
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var added = false;
      /* Gåvor (2026-09-30): en nivå med data-gifts lägger gåvovarianterna i
         korgen i samma anrop som varan, med de dolda egenskaperna _gift_for
         (produktens handle) och _gift_qty (antal som krävs). Rabatten "Gåva vid
         90 dagar" gör dem gratis; assets/ivitapure-gavor.js i temat tar bort dem
         om varan sedan försvinner ur korgen. En gåva som redan ligger i korgen
         läggs inte till igen. Utan gåvor skickas formuläret precis som förut. */
      var picked = f.querySelector('.cpdp-tier-radio:checked');
      var giftIds = picked && picked.dataset.gifts ? picked.dataset.gifts.split(',').filter(Boolean) : [];
      var request;
      if (giftIds.length) {
        request = fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : { items: [] }; }, function () { return { items: [] }; })
          .then(function (cart) {
            var have = {};
            (cart.items || []).forEach(function (it) {
              if (it.properties && it.properties._gift_for) have[String(it.variant_id)] = true;
            });
            var main = { id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 };
            var plan = fd.get('selling_plan');
            if (plan) main.selling_plan = Number(plan);
            var items = [main];
            giftIds.forEach(function (gid) {
              if (have[gid]) return;
              var props = {
                _gift_for: picked.dataset.giftFor || '',
                _gift_qty: String(main.quantity)
              };
              /* Engångspaketet "90 dagar, en leverans" (2026-11-02): utan plan hör gåvan till
                 just paketvarianten, så att assets/ivitapure-gavor.js låter den ligga kvar. */
              if (!plan) props._gift_once = String(main.id);
              items.push({ id: Number(gid), quantity: 1, properties: props });
            });
            return fetch(root + 'cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ items: items, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
            });
          })
          .then(function (r) {
            /* Går en gåva inte att lägga till (t.ex. slut i lager) avvisar Shopify
               hela anropet. Köpet får aldrig stoppas av en gåva: då läggs bara
               varan till, som vanligt. */
            if (r.status === 422) {
              return fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript' } });
            }
            return r;
          });
      } else {
        request = fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/javascript' } });
      }
      request
        .then(function (r) {
          return r.json().then(
            function (j) { return { ok: r.ok, status: r.status, json: j }; },
            function () { return { ok: r.ok, status: r.status, json: null }; }
          );
        })
        .then(function (res) {
          if (res.ok) {
            added = true;
            try {
              f.dispatchEvent(new CustomEvent('cpdp:cart-added', { bubbles: true, detail: { item: res.json } }));
            } catch (err) { /* lyssnarna får inte stoppa köpet */ }
            if (!res.json || !res.json.sections) { window.location.href = root + 'cart'; return; }
            try {
              drawer.renderContents(res.json, !drawer.isOpen);
            } catch (err) {
              window.location.href = root + 'cart';
            }
            return;
          }
          if (res.status === 422) {
            var pb = f.querySelector('[data-cpdp-plan-block]');
            var msg = (res.json && (res.json.description || res.json.message)) ||
                      (pb && pb.getAttribute('data-error-text')) || '';
            if (pb) { showPlanBlock(pb, String(msg)); return; }
          }
          throw new Error('add failed');
        })
        .catch(function () { if (!added) f.submit(); })
        .finally(function () { if (btn) btn.disabled = false; });
    });
  }
})();
